import axios from "axios";

export const headerData = () => {
    return axios
      .get("/page/header")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };